const _ = require('lodash');
const moment = require('moment')

async function findData(context, callback) {

    const countryProjectCollectionName = global.app.I.Country.collectionName
    const zoneProjectCollectionName = global.app.I.Zone.collectionName
    const businessProjectCollection = global.app.I.BusinessProject.collection
    const year = moment().year()
    const businessProjectQuery = businessProjectCollection
        .aggregate([
            {
                $match: {effectiveOfferSubmissionDate: {$ne: null}}
            },
            {
                $project:{
                    offerSubmissionYear: {$year: '$effectiveOfferSubmissionDate'},
                    country: 1,
                    'financialStatement.turnOver.total': 1,
                    estimatedTurnover:1
                }
            },
            {
                $match: {offerSubmissionYear: year}
            },
            {
                $lookup: {
                    from: countryProjectCollectionName,
                    localField: 'country',
                    foreignField: '_id',
                    as: 'country'
                }
            },
            {
                $lookup: {
                    from: zoneProjectCollectionName,
                    localField: 'country.zone',
                    foreignField: '_id',
                    as: 'zone'
                }
            },
            {
                $unwind: '$zone'
            }
        ])
        .toArray()

    const [businessProjects] = await Promise.all([
        businessProjectQuery
    ])


    const formatedBusinessProjects = businessProjects.map(o => {
        const fn = _.get(o, 'financialStatement.turnOver.total')
        return {
            zone: o.zone.code,
            estimatedTurnover: fn ? fn : o.estimatedTurnover
        }
    })
    const dataByZone = _.groupBy(formatedBusinessProjects, 'zone')

    const data = _.sortBy(Object.keys(dataByZone)).map(zone => ({
        axis: zone,
        amount: _.round(_.sumBy(dataByZone[zone], 'estimatedTurnover'), 1),
        number: dataByZone[zone].length
    }))

    const total = _.reduce(data, (acc, o) => {
        return {
            amount: acc.amount + o.amount,
            number: acc.number + o.number
        }
    }, {amount: 0, number: 0})

    return [
        {
            id: "000000000000000000000007",
            subTitle: {
                text: 'offerSubmissionSubtitle',
                data: {
                    year: year,
                    amount: _.round(total.amount, 1),
                    number: total.number
                }
            },
            data
        }
    ]
}

export const entity = {
    name: 'OfferSubmissionPerZone',
    dashboard: true,
    fields: ["id", "subTitle", "data"],
    find: function(context, callback) {
        this.prepareContext(context, 'L', (error, context) => {
            if (error) callback(error)
            else
                findData(context)
                    .then(objects => callback(null, objects))
                    .catch(error => callback(error))
        })
    }
}
